import { useScriptTag } from "@vueuse/core";
import LogRocket from "logrocket";
import { Ref, watch, ref } from "vue";

import config from "@/config";
import usePermissions from "@/hooks/use-permissions";

import { User } from "./use-authentication";

if (config.tracking?.logrocket?.apiKey) {
  LogRocket.init(config.tracking.logrocket.apiKey);
}

interface UserTrackingUtils {
  track: (user: User) => void;
}

const appcuesLoaded = ref(false);

export default function useUserTracking(auth0User: Ref<User | null>): UserTrackingUtils {
  const { canAccessAppcues } = usePermissions();
  const track = (user: User) => {
    /** LogRocket tracking */
    if (config.tracking.logrocket.apiKey) {
      LogRocket.identify(user.email, {
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
      });
    }

    /** Appcues */
    const { load } = useScriptTag(
      "//fast.appcues.com/98208.js",
      () => {
        appcuesLoaded.value = true;
        window.Appcues.identify(user.email, { email: user.email });
      },
      { manual: true }
    );
    if (canAccessAppcues.value && appcuesLoaded.value === false) {
      load();
    }
  };

  watch(
    auth0User,
    (watchedUser) => {
      if (watchedUser) {
        track(watchedUser);
      }
    },
    {
      immediate: true,
    }
  );

  return { track };
}
